module.exports = __webpack_public_path__ + "static/img/icon h spys.6fbbf91d.svg";